export { default } from './DeleteConfirmation';
